import { IListColumnMeta, EFieldType, IFormFieldsMeta } from 'shared/types/Page.interface';

export const FORMALIZED_ZIP_FORM_FIELDS: IFormFieldsMeta = [
  {
    name: 'zipOrderCode',
    label: 'Код запчасти',
    type: EFieldType.input,
    required: true,
  },
  {
    name: 'installationLocation',
    label: 'Место установки',
    type: EFieldType.input,
    required: true,
  },
  {
    name: 'description',
    label: 'Описание',
    type: EFieldType.textarea,
  },
  {
    name: 'count',
    label: 'Количество',
    type: EFieldType.number,
    required: true,
    min: 1,
    max: 1000000,
    step: 1,
  },
] as const;

export const FORMALIZED_ZIP_TABLE_COLUMNS: IListColumnMeta = [
  {
    title: 'Код запчасти',
    type: EFieldType.input,
    dataIndex: 'zipOrderCode',
    sortingPriority: 3,
  },
  {
    title: 'Место установки',
    type: EFieldType.input,
    dataIndex: 'installationLocation',
    sortingPriority: 4,
  },
  {
    title: 'Описание',
    type: EFieldType.input,
    dataIndex: 'description',
    sortingPriority: 5,
  },
  {
    title: 'Количество',
    type: EFieldType.input,
    dataIndex: 'count',
    sortingPriority: 6,
  },
  {
    title: 'Владелец',
    type: EFieldType.input,
    dataIndex: 'ownerName',
    sortingPriority: 7,
  },
  {
    title: 'Компания',
    type: EFieldType.input,
    dataIndex: 'company',
    sortingPriority: 8,
  },
  {
    title: 'Дата создания',
    type: EFieldType.dateTime,
    dataIndex: 'createdAt',
    sourceFormat: 'YYYY-MM-DDTHH:mm:ss',
    targetFormat: 'DD.MM.YYYY HH:mm',
    sortingPriority: 7,
  },
] as const;
